// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + "a29ce42e938ed01bd2a9" + ".chunk.js";
};